import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";
import { DATE_FORMAT } from "src/components/flexComponents/Hotels/utils/constants";
import { Hotel } from "src/typings/microserviceModels/hotels-flex-module";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";

interface PriceLockupSingaporeProps {
  hotel: Hotel;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
}

export const PriceLockupSingapore = ({
  className,
  hotel,
  priceA11y,
  strikeThroughPrice,
  align,
}: PriceLockupSingaporeProps) => {
  const { formattedPrice: lockupPrice, isoCheckIn, isoCheckOut } = hotel;

  const { formatText, formatDateString } = useLocalization();

  const checkInDateFormatted = formatDateString(isoCheckIn, { skeleton: DATE_FORMAT });
  const checkOutDateFormatted = formatDateString(isoCheckOut, { skeleton: DATE_FORMAT });

  /* istanbul ignore next */
  const a11yPrice = priceA11y?.getA11yText() || "";

  const props = {
    lockupPrice,
    priceSubtextFirst: formatText("hotels.price.perNight"),
    priceSubtextStandard: formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted),
    a11yPrice,
    strikeThroughPrice,
    align,
    className,
    /* This text doesn't need to be localized because it's just for a EXPEDIA_SG */
    priceSubtextBold: "Excludes taxes & fees",
  };

  return <UitkPriceLockup {...props} />;
};

export default PriceLockupSingapore;
